/**
 * @generated SignedSource<<5a0c506086e08cb190a5db1c344bfc3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type AccountEditRoleScreenSetRoleMutation$variables = {
  id: string;
  role: Roles;
  storeId?: string | null;
};
export type AccountEditRoleScreenSetRoleMutation$data = {
  readonly store: {
    readonly storeUser: {
      readonly setRole: {
        readonly id: string;
        readonly role: Roles;
      };
    } | null;
  };
};
export type AccountEditRoleScreenSetRoleMutation = {
  response: AccountEditRoleScreenSetRoleMutation$data;
  variables: AccountEditRoleScreenSetRoleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "role"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "StoreUserMutation",
        "kind": "LinkedField",
        "name": "storeUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "role",
                "variableName": "role"
              }
            ],
            "concreteType": "StoreUser",
            "kind": "LinkedField",
            "name": "setRole",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountEditRoleScreenSetRoleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountEditRoleScreenSetRoleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "535a0f913c1ec1ff6f6a63d7f80be96c",
    "id": null,
    "metadata": {},
    "name": "AccountEditRoleScreenSetRoleMutation",
    "operationKind": "mutation",
    "text": "mutation AccountEditRoleScreenSetRoleMutation(\n  $id: ID!\n  $role: Roles!\n  $storeId: ID\n) {\n  store(id: $storeId) {\n    storeUser(id: $id) {\n      setRole(role: $role) {\n        id\n        role\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "23a6f630e2c21b00dfa4baeae977fa1a";

export default node;
